const user = {
    user: {},
    subcovers: [],
    presence: [],
    isFetching: false
};

export default user;
